export default __webpack_public_path__ + "static/media/facebook.09f9c4d8.svg";